import script from "./badge-modal.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./badge-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./badge-modal.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./badge-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__